
import BaseDialog from "../../../components/BaseDialog";
import DialogFooter from "../../../components/DialogFooter";
import { CloseModal } from "../../../hooks/useModal";
import RegisterForm from "../../LoginPage/Register";

interface Props {
  onClose: CloseModal;
}

function CreateUserDialog(props: Props) {
  const { onClose } = props;

  return (
    <BaseDialog
      title={"Tạo mới tài khoản người dùng"}
      width={"40vw"}
      footer={
        <DialogFooter
          cancelProps={{
            onClick: () => onClose(),
          }}
        />
      }
    >
      <RegisterForm isAdministrator setOpenRegisterForm={() => onClose(true)} />
    </BaseDialog>
  );
}
export default CreateUserDialog;
